import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { isEmpty } from '@newfront-insurance/core';
import { useMemo } from 'react';
import { GET_SLASH_COMMANDS, type SlashCommand } from '../queries/chats';
interface UseSlashCommandsOptions {
  accountUuid?: string;
  userUuid?: string;
}
interface SlashCommandGroup {
  category: string;
  commands: SlashCommand[];
}
export function useSlashCommands(t0) {
  const $ = _c(21);
  const {
    accountUuid,
    userUuid
  } = t0;
  const t1 = accountUuid ?? "";
  const t2 = userUuid ?? "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      accountUuid: t1,
      userUuid: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== accountUuid || $[4] !== userUuid) {
    t4 = isEmpty(accountUuid) || isEmpty(userUuid);
    $[3] = accountUuid;
    $[4] = userUuid;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      variables: t3,
      skip: t4,
      fetchPolicy: "cache-and-network"
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data,
    loading,
    error
  } = useQuery(GET_SLASH_COMMANDS, t5);
  data?.slashCommands;
  let t6;
  let t7;
  if ($[9] !== data?.slashCommands) {
    t7 = data?.slashCommands ?? [];
    $[9] = data?.slashCommands;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  t6 = t7;
  const commands = t6;
  let t8;
  let t9;
  if ($[11] !== commands) {
    const groups = {};
    commands.forEach(command => {
      const {
        category
      } = command;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(command);
    });
    t9 = Object.entries(groups).map(_temp);
    $[11] = commands;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  t8 = t9;
  const groupedCommands = t8;
  let t10;
  let t11;
  if ($[13] !== commands) {
    t11 = query => {
      if (isEmpty(query)) {
        return commands;
      }
      const normalizedQuery = query.toLowerCase().replace(/^\//, "");
      return commands.filter(command_0 => command_0.handle.toLowerCase().includes(normalizedQuery) || command_0.description.toLowerCase().includes(normalizedQuery));
    };
    $[13] = commands;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  t10 = t11;
  const filterCommands = t10;
  let t12;
  if ($[15] !== commands || $[16] !== error || $[17] !== filterCommands || $[18] !== groupedCommands || $[19] !== loading) {
    t12 = {
      commands,
      groupedCommands,
      filterCommands,
      isLoading: loading,
      error
    };
    $[15] = commands;
    $[16] = error;
    $[17] = filterCommands;
    $[18] = groupedCommands;
    $[19] = loading;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}
function _temp(t0) {
  const [category_0, categoryCommands] = t0;
  return {
    category: category_0,
    commands: categoryCommands
  };
}